import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from '@/components/Pagination/Pagination';
import { pageWindow } from '@/components/Pagination/pageWindow';

export interface PagerProps {
    page: number;
    pages: number;
    onChange: (page: number) => void;
}

/**
 * The register's pager: previous and next around a window of page numbers (first, last, the
 * current and its neighbours, gaps for the rest), so a hundred-page register takes the same
 * room as a three-page one. A phone gets the position between the two chevrons instead.
 */
function Pager({ page, pages, onChange }: PagerProps) {
    return (
        <Pagination>
            <PaginationContent>
                <PaginationItem>
                    <PaginationPrevious disabled={page === 1} onClick={() => onChange(page - 1)} />
                </PaginationItem>
                {pageWindow(page, pages).map((slot, i) =>
                    slot === 'gap' ? (
                        <PaginationItem key={`gap-${i}`} className="hidden sm:block">
                            <PaginationEllipsis />
                        </PaginationItem>
                    ) : (
                        <PaginationItem key={slot} className="hidden sm:block">
                            <PaginationLink isActive={slot === page} onClick={() => onChange(slot)}>
                                {slot}
                            </PaginationLink>
                        </PaginationItem>
                    ),
                )}
                <PaginationItem
                    className="text-muted-foreground px-2 text-sm tabular-nums sm:hidden"
                    aria-current="page"
                >
                    {page} / {pages}
                </PaginationItem>
                <PaginationItem>
                    <PaginationNext disabled={page === pages} onClick={() => onChange(page + 1)} />
                </PaginationItem>
            </PaginationContent>
        </Pagination>
    );
}

export { Pager };
